module.exports = "<p>\n    admin works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin.component.html
// module id = ./src/app/components/admin/admin.component.html
// module chunks = main